import Axios from "axios";
import {
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
  antdAsyncMessageError,
} from "../../helpers/AsyncMessage";
import {
  antdMessageError,
  antdMessageInfo,
  antdMessageSuccess,
  buildErrorObject,
  errorHandler,
} from "../../helpers/Utils";

export const getTrRequests = (page, filterParams) => async (dispatch) => {
  try {
    const { data } = await Axios.get(
      `/api/v1/tr_requests.json?page=${page}${filterParams}`
    );
    console.log({ data });
    dispatch({
      type: "GET_CUSTOMS",
      payload: { ...data, current: "Technorama" },
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const getTrRequest = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "LOADING_CUSTOM",
    });
    const { data } = await Axios.get(`/api/v1/tr_requests/${id}`);

    if (!data.success) throw new Error("ERR");

    dispatch({
      type: "GET_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const getTrRequestItem =
  (id, shipment_id) => async (dispatch, getState) => {
    try {
      const { data } = await Axios.get(
        `/api/v1/tr_request_items/${id}?shipment_id=${shipment_id}`
      );
      if (!data.success) throw new Error("ERR");
      const reduxData = getState();
      const rebuilArray = {
        ...reduxData.custom.show_data,
        tr_request_items: reduxData.custom.show_data.tr_request_items.map((d) =>
          d.id == data.data.id ? { ...d, ...data.data } : d
        ),
      };
      dispatch({
        type: "GET_CUSTOM",
        payload: rebuilArray,
      });
      antdMessageSuccess();
      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdMessageError();
      return { success: false };
    }
  };

export const postTrRequests = async (params) => {
  try {
    let api_url = "/api/v1/tr_requests";
    if (params.filters) {
      api_url += `?${params.filters}`;
    }
    const { data } = await Axios.post(api_url, params);
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess("Generating");
    // dispatch({
    //   type: "POST_MONEY_REFUND",
    //   payload: data.data,
    // });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return {
      success: false,
      errors: buildErrorObject(err?.response?.data?.errors),
    };
  }
};

export const exportTrRequests =
  (id, type = "basic") =>
  async (dispatch) => {
    try {
      antdAsyncMessageLoading({ key: "exportTrRequests" });
      const { data } = await Axios.post(`/api/v1/tr_requests/${id}/tr_export`, {
        type,
      });
      console.log({ data });
      if (!data.success) throw new Error("ERR");
      antdAsyncMessageSuccess({ key: "exportTrRequests" });
      dispatch({
        type: "UPDATE_CUSTOM",
        payload: data.data,
      });

      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdAsyncMessageError({ key: "exportTrRequests" });
      return {
        success: false,
        errors: buildErrorObject(err?.response?.data?.errors),
      };
    }
  };

export const createTrRequestItem =
  (order_row) => async (dispatch, getState) => {
    try {
      antdAsyncMessageLoading({
        key: "createTrRequestItem",
      });
      const show_data = getState().custom.show_data;
      const { data } = await Axios.post(`/api/v1/tr_request_items`, {
        tr_request_id: show_data.id,
        order_row,
      });
      if (!data.success) throw new Error("ERR");

      antdAsyncMessageSuccess({
        key: "createTrRequestItem",
      });
      dispatch({
        type: "GET_CUSTOM",
        payload: {
          ...show_data,
          tr_request_items: [...show_data.tr_request_items, data.data],
        },
      });
      if (data?.data?.id) {
        const yOffset = -75;
        const element = document.getElementById(`number_${data.data.id}`);
        if (!element) return;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
      return { success: true };
    } catch (err) {
      antdAsyncMessageError({
        key: "createTrRequestItem",
      });
      return { success: false };
    }
  };

export const updateTrRequestItem = (params) => async (dispatch, getState) => {
  try {
    const show_data = getState().custom.show_data;
    const { data } = await Axios.put(`/api/v1/tr_request_items/${params.id}`, {
      tr_request_item: params,
    });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();

    dispatch({
      type: "GET_CUSTOM",
      payload: {
        ...show_data,
        tr_request_items: show_data.tr_request_items.map((d) =>
          d.id == params.id ? { ...d, ...data.data } : d
        ),
      },
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const removeMTrRequestItem = (id) => async (dispatch) => {
  try {
    antdAsyncMessageLoading({
      key: "removeMTrRequestItem",
    });
    const { data } = await Axios.delete(`/api/v1/tr_request_items/${id}`);
    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({
      key: "removeMTrRequestItem",
    });

    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({
      key: "removeMTrRequestItem",
    });
    return { success: false };
  }
};
